// 车辆管理
const Evasion = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/carManagement/evasion.vue"
  );
const WhiteList = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/carManagement/whiteList.vue"
  );
const MonthlyCar = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/carManagement/monthlyCar.vue"
  );
const ChargeRule = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/carManagement/chargeRule.vue"
  );
  const MonthlyCarRenewal = () =>
  import(
    /*webpackChunkName:'operation'*/ "@/page/operation/carManagement/monthlyCarRenewal.vue"
  );
  const FreeTimeRecord=()=> import(
    /*webpackChunkName:'operation'*/ "@/page/operation/carManagement/freeTimeRecord.vue"
  );
const RouteTemp = () =>
  import(/*webpackChunkName:'operation'*/ "@/page/commons/routeTemp.vue");

export const vehicle = {
  path: "/main/vehicleManagement",
  name: "车辆管理",
  component: RouteTemp,
  children: [
    {
      path: "/main/vehicleManagement/evasion",
      name: "逃费车辆",
      component: Evasion,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/vehicleManagement/free",
      name: "vip车辆",
      component: WhiteList,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/vehicleManagement/monthlyCar",
      name: "月租车辆",
      component: MonthlyCar,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/vehicleManagement/monthlyCarChargeRule",
      name: "月租车收费规则",
      component: ChargeRule,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/vehicleManagement/monthlyCar/renewal",
      name: "月租续费",
      component: MonthlyCarRenewal,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/main/vehicleManagement/free/free-time-detail",
      name: "免时详情",
      component: FreeTimeRecord,
      meta: {
        requireAuth: true,
      },
    },
  ],
};
